<template>
  <div class="comparison-table-cell">
    <div class="new-value">
      {{ value }}
    </div>
    <div class="old-value" v-if="showOldValue">{{ oldValue }}</div>
  </div>
</template>

<script>
export default {
  name: "ReviewsAnalystComparisonTableCell",
  props: {
    oldValue: {
      type: Number,
      required: true
    },
    value: {
      type: Number,
      required: true
    },
    inversedArrows: {
      type: Boolean,
      default: () => false
    },
    showOldValue: {
      type: Boolean,
      default: () => true
    }
  },
  data() {
    return {
      positiveColor: "green-1",
      negativeColor: "red-1"
    };
  }
};
</script>

<style lang="scss" scoped>
.comparison-table-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: $font-family-base;
  user-select: none;
  padding-top: 15px;
  padding-bottom: 15px;
  min-height: 78px;

  .new-value {
    @include font-size(18px);
    line-height: 22px;
    font-weight: 500;
    color: $primary;
    position: relative;

    .v-icon {
      position: absolute;
      right: -20px;
      top: 1px;
      font-size: 18px;
    }
  }

  .old-value {
    @include font-size(14px);
    font-weight: 400;
    line-height: 17px;
    color: $grey-darker;
    padding-top: 9px;
  }
}
</style>
